import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEnterOrSpace } from '@Utils/KeyboardUtil';
import { createE2EClass } from '@Utils/String';

import './SwitchBox.theme.scss';

function SwitchBox({ size, ariaLabel, className, e2eName, name, disabled, checked, onChange }) {
  const onCheckboxChange = (event) => {
    if (event && event.currentTarget && !disabled && onChange) {
      const isChecked = event.currentTarget.checked;
      onChange(event, isChecked);
    }
  };

  const onKeyDown = (event) => {
    if (isEnterOrSpace(event)) {
      event.preventDefault();
      event.stopPropagation();
      if (onChange) {
        onChange(event, !checked);
      }
    }
  };

  return (
    <input
      aria-label={ariaLabel}
      className={classnames(className, 'es-switch-input', size, { [`${createE2EClass(e2eName, true)}`]: e2eName })}
      disabled={disabled}
      name={name}
      type="checkbox"
      checked={checked}
      onChange={onCheckboxChange}
      onKeyDown={onKeyDown}
    />
  );
}

SwitchBox.defaultProps = {
  checked: false,
};

SwitchBox.propTypes = {
  size: PropTypes.string, // xs, small, medium, large
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  e2eName: PropTypes.string.isRequired,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default SwitchBox;
